import { AbstractSearchCriteria } from './abstract-search-criteria';
import {KeyControlAndAbstractSearchCriteria} from './key-control-and-abstract-search-criteria';

export class ConfigurationSearchCriteria extends KeyControlAndAbstractSearchCriteria{
    code = '';
}
